import React, { useState } from "react";
import "react-modal-video/css/modal-video.css";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import styled from "styled-components";
import Counter from "../../public/assets/images/bg/counter-1.png";
import Video from "../Generic/Video";

const Activities = (activity) => {
  const [isOpen, setIsOpen] = useState(false);
  const [url, setURL] = useState("");
  const handleVideoModal = () => {
    setIsOpen(!isOpen)
  }

  //   const VideoBackGroundImage = styled.div`
  //   background-image: linear-gradient(rgba(18, 19, 24, 0.5),rgba(18, 19, 24, 0.9)),url(${activity.activity.video_thumb_url});
  //   background-size: cover;
  //   background-repeat: no-repeat;
  //   background-position: center;
  // `;
  return (
    <>
      <div className="activities-section">
        {/* <div className="section-title2 primary3 text-start mb-0">
                <span>{activity.activity.title}</span>
                <div>
                  <h2>{activity.activity.highlist_title}</h2>
                  <p className="para">
                    {activity.activity.sub_title}
                  </p>
            </div>
          </div> */}
        <div className="activities-area">
          <div className="row justify-content-center">
            {/* <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <VideoBackGroundImage className="company-vdo position-relative " >
                  <div className="video-play style-2">
                    <div
                      style={{ cursor: "pointer" }}
                      className="popup-youtube video-icon">
                      <a onClick={() => {
                        setURL(activity.activity.video_url)
                        handleVideoModal()
                      }}
                        href={(e) => e.preventDefault}>
                        <i className="bx bx-play" />
                      </a>
                    </div>
                  </div>
                </VideoBackGroundImage>
              </div> */}
            <div className="company-counter" >
              <div className="row ">
                {
                  activity.activity.client_review_section.length &&
                  activity.activity.client_review_section.map((review, index) => {
                    const oddEvenClass = index % 2 === 0 ? "odd" : "even";
                    return (
                      <div key={index} className={`col-lg-3 col-md-6 col-sm-6 col-6 counter-item ${oddEvenClass}`} >
                        <div
                          className="counter-single text-start" >
                          <div className="line line-top"></div>
                          <div className="line line-bottom"></div>
                          <div className="line line-left"></div>
                          <div className="line line-right"></div>
                          <div className="coundown d-flex flex-column">
                            <img src={review.icon_image} className="ico" alt="counter-image" />

                            <h2 className="odometer">
                              {/* <CountUp
                              end={review.count}
                              duration={2}
                              suffix=" +"
                            /> */}
                              {review.count} +
                            </h2>
                            {review.title}
                          </div>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        isOpen &&
        <Video handleVideoModal={handleVideoModal} url={url} />
      }
    </>
  );
}

export default Activities;